export const referentkaDevFirebaseConfig = {
    apiKey: 'AIzaSyAsuxvncWTIMikFZ9MTj5vjMkCKZ9HebAI',
    authDomain: 'referentka-11e99.firebaseapp.com',
    projectId: 'referentka-11e99',
    storageBucket: 'referentka-11e99.appspot.com',
    messagingSenderId: '922177552449',
    appId: '1:922177552449:web:efa1f7aafe0021422e06c0',
    measurementId: 'G-R2EHCR33EJ',
};
